var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { PollStatus, PollAnswerType, PollRepository } from '@amityco/js-sdk';
import { VoteItemContainer, ResultItemContainer, Title, PollInformation, SubmitButton, Text, ChipContainer, VoteCounter, ProgressBarContainer, ProgressBar, } from './styles';
import { Chip } from '../../../../core/components/Radio/styles';
import ConditionalRender from '../../../../core/components/ConditionalRender';
import { useAsyncCallback } from '../../../../core/hooks/useAsyncCallback';
import usePoll from '../../../../social/hooks/usePoll';
const MILLISECONDS_IN_DAY = 86400000;
const VoteItem = ({ data: text, onCheck, checked }) => {
    return (React.createElement(VoteItemContainer, { checked: checked, onClick: onCheck },
        React.createElement(ChipContainer, null,
            React.createElement(Chip, { checked: checked }),
            React.createElement(Text, null, text))));
};
const ResultItem = ({ data: text, voteCount, totalVotes = 0, isVotedByUser }) => {
    const percentage = voteCount && totalVotes ? (voteCount / totalVotes) * 100 : 0;
    return (React.createElement(ResultItemContainer, { checked: isVotedByUser },
        React.createElement(Text, null, text),
        React.createElement(ProgressBarContainer, null,
            React.createElement(ProgressBar, { percentage: percentage, checked: isVotedByUser })),
        React.createElement("div", null,
            React.createElement(FormattedMessage, { id: "poll.votes", values: { voteCount } }))));
};
const VoteList = ({ answers, handleCheck, answerIds }) => {
    return answers.map((_a) => {
        var { id } = _a, answer = __rest(_a, ["id"]);
        return (React.createElement(VoteItem, Object.assign({ key: id, checked: answerIds.includes(id), onCheck: () => handleCheck(id) }, answer)));
    });
};
const ResultList = ({ answers, totalVotes }) => {
    return answers.map((_a) => {
        var { id } = _a, answer = __rest(_a, ["id"]);
        return (React.createElement(ResultItem, Object.assign({ key: id }, answer, { totalVotes: totalVotes })));
    });
};
const PollContent = ({ items }) => {
    var _a, _b;
    const pollId = (_b = (_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.pollId;
    const { poll } = usePoll(pollId);
    const { answers = [], answerType, closedIn, isDeleted, isVoted, status } = poll;
    const isClosed = status === PollStatus.Closed;
    const totalVotes = answers.reduce((sum, answer) => sum + answer.voteCount, 0);
    const canSelectMultiple = answerType === PollAnswerType.Multiple;
    const [answerIds, setAnswerIds] = useState([]);
    const { formatMessage } = useIntl();
    const handleCheck = (answerId) => {
        if (answerIds.includes(answerId)) {
            const index = answerIds.findIndex((id) => id === answerId);
            setAnswerIds((prevAnswerIds) => [
                ...prevAnswerIds.splice(0, index),
                ...prevAnswerIds.splice(index + 1),
            ]);
        }
        else if (canSelectMultiple) {
            setAnswerIds((prevAnswerIds) => [...prevAnswerIds, answerId]);
        }
        else {
            setAnswerIds([answerId]);
        }
    };
    const [handleSubmit] = useAsyncCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (isClosed || isDeleted) {
            throw new Error(formatMessage({ id: 'poll.error.deletedOrClosed' }));
        }
        yield PollRepository.votePoll(pollId, answerIds);
    }), [answerIds, pollId]);
    const closedInDays = Math.floor(closedIn / MILLISECONDS_IN_DAY);
    return (React.createElement("div", null,
        React.createElement(PollInformation, null,
            React.createElement(Title, null,
                React.createElement(ConditionalRender, { condition: !isClosed },
                    React.createElement(FormattedMessage, { id: "poll.vote.closedIn", values: { closedIn: closedInDays } }),
                    React.createElement(FormattedMessage, { id: "poll.vote.finalResults" }))),
            React.createElement(VoteCounter, null,
                React.createElement(FormattedMessage, { id: "poll.votes", values: { voteCount: totalVotes } }))),
        React.createElement(ConditionalRender, { condition: !isClosed },
            React.createElement(ConditionalRender, { condition: !isVoted },
                React.createElement(VoteList, { answers: answers, handleCheck: handleCheck, answerIds: answerIds }),
                React.createElement(ResultList, { answers: answers, totalVotes: totalVotes })),
            React.createElement(ResultList, { answers: answers })),
        !isVoted && !isClosed && (React.createElement(SubmitButton, { disabled: !answerIds.length, onClick: handleSubmit },
            React.createElement(FormattedMessage, { id: "poll.vote.submit" })))));
};
PollContent.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default PollContent;
//# sourceMappingURL=index.js.map